import { useFetchData } from "../../../hooks/useFetch";
import { BasePaginateResponse } from "../../../models/response/base-response";
import { NotificationResponse, NotificationReadStatus } from "../../../models/response/notification/notification";
import { API_NOTIFICATION_ROUTER, ApiConfig } from "../../../services/api-config";


export const NotificationService = {
  getListNotification: () => {
    const { request, baseResponse, loading } = useFetchData.Get<BasePaginateResponse<NotificationResponse[]>>({
      projectId: ApiConfig.PROJECT_ID.LOG_SERVICE,
    });
    return {
      fetch: (params: { page?: number; limit?: number; status: number; key_search?: string }) =>
        request({
          endPoint: API_NOTIFICATION_ROUTER.API_GET_NOTIFICATION,
          data: params,
        }),
      response: baseResponse,
      loading: loading,
    };
  },

  getNotificationCountRead: () => {
    const { request, baseResponse, loading } = useFetchData.Get<NotificationReadStatus>({
      projectId: ApiConfig.PROJECT_ID.LOG_SERVICE,
    });
    return {
      fetch: () =>
        request({
          endPoint: API_NOTIFICATION_ROUTER.API_COUNT_READ,
        }),
      response: baseResponse,
      loading: loading,
    };
  },
  makeAsRead: () => {
    const { request, baseResponse, loading } = useFetchData.Post({
      projectId: ApiConfig.PROJECT_ID.LOG_SERVICE,
    });
    return {
      fetch: (id: string) =>
        request({
          endPoint: API_NOTIFICATION_ROUTER.API_MARK_AS_READ(id),
        }),
      response: baseResponse,
      loading: loading,
    };
  },

  makeAsReadAll: () => {
    const { request, baseResponse, loading } = useFetchData.Post({
      projectId: ApiConfig.PROJECT_ID.LOG_SERVICE,
    });
    return {
      fetch: () =>
        request({
          endPoint: API_NOTIFICATION_ROUTER.API_MARK_AS_READ_ALL,
        }),
      response: baseResponse,
      loading: loading,
    };
  },
};
